<template>
  <div ref="stickyWrapper" class="card_wrap">
    <!-- 顶部 TabBar，吸顶逻辑通过 isFixed 控制 -->
    <TabBar
      v-model="selectedLabelDefault"
      :data="tabs"
      :class="{ fixed: isFixed }"
      :style="{ top: isFixed ? `${headerHeight}px` : '0px' }"
      @click="clickHandler"
      @change="changeHandler"
    />
    <van-list v-model="loading" :finished="finished" @load="initData">
      <detail
        v-for="(item, index) in list"
        :key="index"
        class="detail"
        :membershipPeriod="membershipPeriod"
        :item="item"
      />
      <div slot="loading" class="loading-text">
        {{ $t('FoodOpB_account_Loading_EDDu') }}
      </div>
    </van-list>
    <no-data
      v-if="!list.length && !loading"
      :linkInfo="linkInfo"
      :selectedLabelDefault="selectedLabelDefault"
    />
  </div>
</template>

<script>
import mixin from '@/page/member/mixins.js'
import { TabBar } from '@didi/rich-ui'
import detail from './detail.vue'
import noData from './no-data.vue'
import { getMembershipOrders } from '@/api/member/index.js'
import trackEvent from '@/common/js/track'

export default {
  name: 'MemberCard',
  components: {
    TabBar,
    detail,
    noData,
  },
  mixins: [mixin],
  props: {
    headerHeight: {
      type: Number,
      default: 0, // 吸顶时顶部偏移
    },
    savingMoneyCount: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedLabelDefault: 'Food', // 默认选中的 tab
      tabs: [
        { label: this.$t('FoodC_bill_zfEm_MWKg'), value: 'Food' },
        { label: this.$t('FoodC_bill_jWTz_UdyX'), value: 'Shop' },
        { label: this.$t('FoodC_bill_qjez_JBnr'), value: 'Ride' },
        { label: this.$t('FoodC_bill_DRvJ_yzMg'), value: 'Entrega' },
      ],
      offsetTop: 0, // 吸顶参考位置
      isFixed: false, // 是否吸顶
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 20,
      list: [],
      membershipPeriod: {},
      linkInfo: {},
      shownPeriods: new Set(),
    }
  },
  mounted() {
    // 获取组件的偏移量
    this.offsetTop = this.$refs.stickyWrapper.offsetTop
    // 监听窗口滚动事件
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },
  beforeDestroy() {
    // 组件卸载时移除事件监听
    window.removeEventListener('scroll', this.handleScroll)
  },
  created() {
    this.trackEvent()
  },
  methods: {
    clickHandler(label) {},
    // tab 变更（
    changeHandler(label) {
      this.shownPeriods.clear()
      this.finished = false
      this.pageNum = 1
      this.list = []
      this.initData()
      this.trackEvent()
    },
    // 埋点上报
    trackEvent() {
      // 埋点上报
      trackEvent({
        eventId: 'sailing_c_x_membership_savingpage_ck',
        eventLabel: '会员已省明细页面点击埋点',
        attrs: {
          totalsaving: this.savingMoneyCount?.totalSavingMoneyTran,
          foodsaving: this.savingMoneyCount?.foodSavingMoneyTran,
          grocerysaving: this.savingMoneyCount?.shopSavingMoneyTran,
          ridesaving: this.savingMoneyCount?.rideSavingMoneyTran,
          entregasaving: this.savingMoneyCount?.entregaSavingMoneyTran,
          click_type: this.tabs.findIndex(tab => tab.value === this.selectedLabelDefault) + 1,
        },
      })
    },
    // 处理吸顶逻辑
    handleScroll() {
      this.isFixed = window.scrollY >= this.offsetTop - this.headerHeight
    },
    async initData() {
      this.loading = true
      try {
        // 获取会员订单数据
        const res = await getMembershipOrders({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          bizLine: this.selectedLabelDefault,
        })
        const data = res?.data?.data ?? {}
        // 更新会员期限信息
        this.membershipPeriod = data.membershipPeriod ?? {}
        // 更新链接信息
        this.linkInfo = data.linkInfo ?? {}
        // 获取订单列表
        const orderList = Array.isArray(data.orderList) ? data.orderList : []
        // 如果有订单数据
        if (orderList.length > 0) {
          // 标记每个时间段的第一个订单
          this.markPeriodFirsts(data.orderList)
          this.list.push(...data.orderList)
          this.pageNum++
          this.finished = orderList.length < this.pageSize
        } else {
          this.finished = true
        }
      } catch (error) {
        this.finished = true
      } finally {
        this.loading = false
      }
    },
    markPeriodFirsts(newOrders) {
      // 遍历新获取的订单
      for (const order of newOrders) {
        // 如果当前订单的时间段未显示过
        if (!this.shownPeriods.has(order.membershipPeriod)) {
          // 标记为时间段的第一个订单
          order.isFirstOfPeriod = true
          // 添加到已显示的时间段集合
          this.shownPeriods.add(order.membershipPeriod)
        } else {
          // 如果已显示过，则不是第一个
          order.isFirstOfPeriod = false
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: #ffffff;
  padding: 0 32px;
}

.card_wrap {
  background: #ffffff;
  border-radius: 64px 64px 0 0;
  padding: 12px 32px;
  ::v-deep .rich-tab-bar {
    font-size: 32px;
    .rich-tab {
      font-family: DiDiSans-Pro-Regular;
      color: #89898c;
    }
    .rich-tab_active {
      font-family: DiDiSans-Pro-Bold;
      font-size: 32px;
      color: #0b0b0d;
    }
  }
  .loading-text {
    padding-bottom: 150px;
  }
  .detail {
    margin-bottom: 24px;
  }
}
</style>
